<template>
    <review-board course-source="Normal"></review-board>
</template>

<script>
import ReviewBoard from './ReviewBoard.vue';

export default {
    name: 'ClassroomQualityNormalReview',
    components: { ReviewBoard },
};
</script>
